/* This is used to reformat the upload field */
/* Ensure .uploadfile class is assigned to the parent field container */

import lib from "./../js-lib/lib.js";

const Gform_Upload = {
  render: () => {
    let container = lib.qs(".uploadfile");

    let input = lib.qs('input[type="file"]');

    if (!container || !input) {
      return;
    }

    let desc = lib.qs(".uploadfile > .gfield_description");
    if (!desc) {
      return;
    }

    desc.innerHTML = `CHOOSE FILE <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.5 27"><path d="M11.659 6.136V20.25a4.909 4.909 0 1 1-9.818 0V4.909a3.068 3.068 0 1 1 6.136 0V17.8a1.228 1.228 0 0 1-2.455 0V6.136h-1.84V17.8a3.068 3.068 0 0 0 6.136 0V4.909a4.909 4.909 0 1 0-9.818 0V20.25a6.75 6.75 0 1 0 13.5 0V6.136Z" /></svg>`;

    const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    input.addEventListener("change", () => {
      let bytes = 0;

      for (const file of input.files) {
        bytes = file.size;
      }

      // Calculate Unit Type
      const exponent = Math.min(
        Math.floor(Math.log(bytes) / Math.log(1024)),
        units.length - 1
      );

      const approx = bytes / 1024 ** exponent;

      const output =
        exponent === 0
          ? `${bytes} bytes`
          : `${approx.toFixed(3)} ${units[exponent]}`;

      if (bytes > 0) {
        desc.innerHTML = `File Uploaded (${output})`;
      }

      if (bytes <= 0) {
        desc.innerHTML = `CHOOSE FILE <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.5 27"><path d="M11.659 6.136V20.25a4.909 4.909 0 1 1-9.818 0V4.909a3.068 3.068 0 1 1 6.136 0V17.8a1.228 1.228 0 0 1-2.455 0V6.136h-1.84V17.8a3.068 3.068 0 0 0 6.136 0V4.909a4.909 4.909 0 1 0-9.818 0V20.25a6.75 6.75 0 1 0 13.5 0V6.136Z" /></svg>`;
      }
    });
  },
};

export { Gform_Upload as default };
